import * as React from 'react';

import {Checkbox} from 'shells/checkbox/checkbox';
import {Popover} from 'shells/popover/popover';
import {PopoverForm} from 'shells/popover-form/popover-form';

import {UnlockError} from './unlock-error';

import styles from './unlock-popover.module.css';

type Props = {
    selectedItemCount: number;
    unlockLimit: number;
    unlockedThisMonth: number;
    onUnlock: () => void;
    onClose: () => void;
    anchor: HTMLElement;
    isSaving: boolean;
    dontAskAgain: boolean;
    setDontAskAgain: (arg1: boolean) => void;
};

export function UnlockPopover(props: Props) {
    const hasUnlockedLimit = props.unlockLimit === props.unlockedThisMonth;
    const isOverLimit = props.unlockLimit - props.unlockedThisMonth - props.selectedItemCount < 0;

    const errorTitle = hasUnlockedLimit
        ? `All ${props.unlockLimit} companies have been unlocked this month`
        : `${props.unlockedThisMonth} companies have been unlocked this month`;

    const errorInfo = hasUnlockedLimit ? (
        <div>
            <p>Come back on the 1st to unlock more.</p>
            <p>Soon, you’ll also be able to purchase additional credits to use each month.</p>
        </div>
    ) : (
        <div>
            Select <strong>up to {props.unlockLimit - props.unlockedThisMonth} companies</strong> to
            stay within your monthly limit.
        </div>
    );

    if (hasUnlockedLimit || isOverLimit) {
        return (
            <UnlockError
                title={errorTitle}
                info={errorInfo}
                // @ts-expect-error
                unlockLimit={props.unlockLimit}
                unlockedThisMonth={props.unlockedThisMonth}
                anchor={props.anchor}
                onClose={props.onClose}
            />
        );
    }

    return (
        <Popover anchor={props.anchor} onBlur={props.onClose} location='top'>
            <PopoverForm
                width={340}
                allowTitleWrapping={true}
                onClose={props.onClose}
                title={`Are you sure you’d like to unlock ${props.selectedItemCount} ${
                    props.selectedItemCount === 1 ? 'company' : 'companies'
                }?`}
                isSaving={props.isSaving}
                saveButtonSavingText='Unlocking'
                saveButtonSuccessText='Unlocked!'
                onSubmit={props.onUnlock}
                saveButtonText='Yes, unlock'
                cancelButtonText='No, don’t unlock'
                resetOnSaveComplete={true}
                saveCompleteTimeout={1000}
            >
                <div className={styles['form-container']}>
                    <div className={styles.info}>{`You’ll have ${
                        props.unlockLimit - props.unlockedThisMonth - props.selectedItemCount
                    } remaining`}</div>
                    <Checkbox
                        label='Don’t ask me again'
                        checked={props.dontAskAgain}
                        onChange={props.setDontAskAgain}
                    />
                </div>
            </PopoverForm>
        </Popover>
    );
}
